export const SIZE_WIDESCREEN = 1216;
export const TABLET = 'tablet';
export const WIDESCREEN = 'widescreen';

export function nameSizeScreenGetter() {
  let name = TABLET;
  if (window.innerWidth >= SIZE_WIDESCREEN) { // Magic constant coming from bulma
    name = WIDESCREEN;
  }
  return name;
}

export function isTablet() {
  return nameSizeScreenGetter() === TABLET;
}

export function isWidescreen() {
  return nameSizeScreenGetter() === WIDESCREEN;
}



// WEBPACK FOOTER //
// ./src/services/general/sizeScreenGetter.js